<template>
  <HighFrequencyGameOptionCard
    :headline="$t('highfrequencygame.chargeselectorcard.headline')"
    :subtitle="$t('highfrequencygame.chargeselectorcard.subtitle')"
  >
    <ChargeSelector
      v-model:value="model"
      :aria-label="$t('highfrequencygame.chargeselectorcard.arialabel')"
      :charges="preparedWagers"
    />
  </HighFrequencyGameOptionCard>
</template>

<script lang="ts" setup>
import type { HighFrequency_WagersConfig } from '#api/shared/@types/generated/backend/graphql-schema-types'

type Props = {
  wagers: Omit<HighFrequency_WagersConfig, 'fee'>[]
}

const { wagers } = defineProps<Props>()
const model = defineModel({ default: '', type: String })

const preparedWagers = computed(() =>
  wagers.map((wager) => ({
    id: wager.name,
    value: wager.price.amount.value,
  })),
)
</script>
